<template>
  <v-dialog v-model="showTimePeriodModal" max-width="500" persistent>
    <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }">
      <v-card-title class="justify-space-between pa-0">
        <div :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs, 'fw-600': true }">
          Add Time Period <b class="pl-2"></b>
        </div>
        <v-btn icon @click="$emit('close-timePeriod-dialog', true)">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
        <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }" class="w-100">
          <v-row>
            <v-col cols="12" :xs="12" :sm="12" :md="12" :lg="12">
              <TextField
                v-model="timePeriodObject.description"
                rules="required"
                :loading="isTimePeriodFormLoading"
                label="Description"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <DateField
                v-model="timePeriodObject.startDate"
                rules="required"
                :loading="isTimePeriodFormLoading"
                :inputLabel="'Start Date'"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <DateField
                v-model="timePeriodObject.endDate"
                rules="required"
                :loading="isTimePeriodFormLoading"
                :inputLabel="'End Date'"
              />
            </v-col>
          </v-row>
          <div class="d-block d-sm-flex justify-center">
            <v-btn
              width="140"
              color="button-primary"
              large
              :block="breakpointXs"
              :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
              :loading="loader"
              @click="passes(addTimePeriod(timePeriod))"
            >
              <span class="font-weight-bold fs-15">Add New</span>
            </v-btn>
            <!-- <v-btn
              width="140"
              color="button-primary"
              large
              v-if="timePeriod.action === 'edit'"
              :block="breakpointXs"
              :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
              :loading="isTimePeriodFormLoading"
              @click="passes(updateTimePeriod(timePeriod))"
            >
              <span class="font-weight-bold fs-15">update</span>
            </v-btn> -->
          </div>
        </ValidationObserver>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>
<script lang="js">
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import DateField from "@/components/DateField";
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "TimePeriod",
    components: {
    ValidationObserver,
    TextField,
    DateField
  },
  data() {
	  return {
          description: "",
          endDate: "",
          startDate: "",
          showTimePeriodModal: true,
          isTimePeriodFormLoading: false,
	  }
  },
    props: {
    loader:{
        type: Boolean,
        default: false
    },
    timePeriodObject: {
      type: Object,
      default: () => {
        return {
              id:'',
              description:'',
              startDate:'',
              endDate:'',
              action:'add'
        };
      }
    }
  },
  mixins:[commonMethodsMixin],
  computed: {
          tableHeaders() {
      return [
        { text: "Sr No.", value: "id", align: "center" },
        { text: "Description", value: "bifurcation", align: "center" },
        { text: "End Date", value: "end_date", align: "center" },
        { text: "Action", value: "deleteAction", align: "center" }
      ];
    },
  },
  methods: {
    addTimePeriod(timePeriod) {
        this.$emit('add-timePeriod',timePeriod);
    },
    updateTimePeriod(timePeriod) {
        this.$emit('update-timePeriod',timePeriod);
    },
  },
}
</script>
